document.addEventListener("DOMContentLoaded", () => {

    const blocks = document.querySelectorAll(".p7-search-list-block");

    blocks.forEach(block => {

        if (block.dataset.p7SearchListInit) return;
        block.dataset.p7SearchListInit = "1";

        const container = block.querySelector(".p7-search-list-inner");
        const loadMoreBtn = block.querySelector(".p7-load-more");

        const searchForm = block.querySelector(".p7-search-filter-form");
        const searchInput = block.querySelector(".p7-universal-search-input");

        const clearSearchBtn = block.querySelector(".p7-search-clear");
        const clearSearchLink = block.querySelector(".p7-clear-search");

        const suggestionsBox = block.querySelector(".p7-search-suggestions");
        const resultsTitleContainer = block.querySelector(".p7-search-results-title-container");

        const showSuggestions = block.dataset.showSuggestions === "1";

        const nonce = block.dataset.nonce;
        const ajaxUrl = block.dataset.ajaxurl;

        let page = 1;
        let currentSearch = '';

        const attributes = JSON.parse(block.dataset.attributes || '{}');

        // ------------------------
        // helpers
        // ------------------------

        function getUrlParam(name) {
            const params = new URLSearchParams(window.location.search);
            return params.get(name) || '';
        }

        function updateUrl(searchTerm) {
            const url = new URL(window.location);
            if (searchTerm) {
                url.searchParams.set("q", searchTerm);
            } else {
                url.searchParams.delete("q");
            }
            window.history.pushState({}, "", url.toString());
        }

        // ------------------------
        // initial state
        // ------------------------

        const urlSearch = getUrlParam("q");
        if (urlSearch && searchInput) {
            searchInput.value = urlSearch;
            currentSearch = urlSearch;
            if (clearSearchBtn) {
                clearSearchBtn.style.display = "flex";
            }
        }

        // ------------------------
        // suggestions
        // ------------------------

        if (searchInput && suggestionsBox && showSuggestions) {

            let timer;
            let lastHTML = "";

            searchInput.addEventListener("input", e => {
                clearTimeout(timer);
                const value = e.target.value.trim();
                if (clearSearchBtn) {
                    clearSearchBtn.style.display = value ? "flex" : "none";
                }
                if (value.length < 3) {
                    suggestionsBox.style.display = "block";
                    suggestionsBox.innerHTML = `
                        <div class="p7-search-no-results">
                            Please type more than 2 letters
                        </div>
                    `;
                    lastHTML = "";
                    return;
                }

                timer = setTimeout(async () => {
                    const formData = new FormData();
                    formData.append("action", "p7_search_suggestions");
                    formData.append("nonce", nonce);
                    formData.append("term", value);
                    try {
                        const response = await fetch(ajaxUrl, {
                            method: "POST",
                            body: formData
                        });
                        const data = await response.json();

                        if (!data.success) {
                            suggestionsBox.style.display = "none";
                            lastHTML = "";
                            return;
                        }
                        const g = data.data;
                        let html = "";
                        const group = (title, items, type) => {
                            if (!items?.length) return "";
                            return `
                                <div class="p7-search-group">
                                    <div class="p7-search-heading">
                                        ${title}
                                    </div>
                                    ${items.map(item => {
                                let meta = "";

                                if (type === "community") {
                                    meta = item.city ?? "";
                                }

                                if (type === "plan") {
                                    meta = [item.city, item.community].filter(Boolean).join(" • ");
                                }

                                if (type === "home") {
                                    meta = item.address ?? "";
                                }

                                return `
                                            <div
                                                class="p7-search-suggestion"
                                                data-url="${item.url}"
                                            >

                                                ${item.image ? `
                                                    <img
                                                        src="${item.image}"
                                                        class="p7-search-thumb"
                                                    >
                                                ` : ""}

                                                <div>

                                                    <div class="p7-search-title">
                                                        ${item.title}
                                                    </div>

                                                    ${meta ? `
                                                        <div class="p7-search-meta">
                                                            ${meta}
                                                        </div>
                                                    ` : ""}

                                                </div>

                                            </div>
                                        `;
                            }).join("")}
                                </div>
                            `;
                        };

                        html += group("Communities", g.communities, "community");
                        html += group("Plans", g.plans, "plan");
                        html += group("Homes", g.homes, "home");
                        html += group("Pages", g.pages);
                        html += group("Posts", g.posts);
                        html += group("Locations", g.locations);
                        html += group("Promotions", g.promotions);

                        lastHTML = html || `
                            <div class="p7-search-no-results">
                                No data found
                            </div>
                        `;

                        suggestionsBox.innerHTML = lastHTML;
                        suggestionsBox.style.display = "block";
                    } catch (e) {
                        suggestionsBox.style.display = "none";
                        lastHTML = "";
                    }
                }, 300);

            });

            suggestionsBox.addEventListener("click", e => {
                const item = e.target.closest(".p7-search-suggestion");
                if (item) {
                    window.location.href = item.dataset.url;
                }
            });

            document.addEventListener("click", e => {
                if (!block.contains(e.target)) {
                    suggestionsBox.style.display = "none";
                }
            });
        }

        // ------------------------
        // load results
        // ------------------------

        async function loadHomes(isNewSearch = false) {

            try {
                if (isNewSearch) {
                    page = 1;
                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = "none";
                    }
                }

                const formData = new FormData();
                formData.append("action", "p7_search_list");
                formData.append("nonce", nonce);
                formData.append("page", page);
                formData.append("attributes", JSON.stringify(attributes));
                formData.append("universal_search", currentSearch);

                const response = await fetch(ajaxUrl, {
                    method: "POST",
                    body: formData
                });

                const result = await response.json();

                if (!result.success) {
                    return;
                }

                if (page === 1) {
                    container.innerHTML = result.data.html;
                } else {
                    container.insertAdjacentHTML(
                        "beforeend",
                        result.data.html
                    );

                }

                // title

                if (resultsTitleContainer) {
                    if (currentSearch) {
                        resultsTitleContainer.innerHTML = `
                            <h2 class="p7-search-results-title">
                                Search Results for
                                "${currentSearch}"
                            </h2>
                        `;
                    } else {
                        resultsTitleContainer.innerHTML = "";
                    }

                }

                // load more logic
                if (loadMoreBtn) {
                    const showing = result.data.showing || 0;
                    const total = result.data.total_found || 0;
                    const hasMore = showing < total;
                    loadMoreBtn.style.display =
                        hasMore ? "block" : "none";
                }
            } catch (e) {
                console.log(e);
            }
        }

        // initial load
        if (container) {
            loadHomes();
        }

        // submit
        if (searchForm) {
            searchForm.addEventListener("submit", e => {
                // e.preventDefault();
                const value = searchInput.value.trim();
                if (value !== currentSearch) {
                    currentSearch = value;
                    updateUrl(value);
                    loadHomes(true);
                }
            });
        }

        // enter key

        if (searchInput) {
            searchInput.addEventListener("keypress", e => {
                if (e.key === "Enter") {
                    searchForm.dispatchEvent(
                        new Event("submit")
                    );
                }
            });
        }

        // clear button

        if (clearSearchBtn) {
            clearSearchBtn.addEventListener("click", () => {
                searchInput.value = "";
                currentSearch = "";
                updateUrl("");
                clearSearchBtn.style.display = "none";
                if (suggestionsBox) {
                    suggestionsBox.style.display = "none";
                    suggestionsBox.innerHTML = "";
                }
                loadHomes(true);
            });
        }

        // clear link

        if (clearSearchLink) {
            clearSearchLink.addEventListener("click", e => {
                e.preventDefault();
                searchInput.value = "";
                currentSearch = "";
                updateUrl("");
                loadHomes(true);
            });
        }

        // load more

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener("click", e => {
                e.preventDefault();
                page++;
                loadHomes();
            });
        }

        // browser back button
        window.addEventListener("popstate", () => {
            const value = getUrlParam("q");
            searchInput.value = value;
            currentSearch = value;
            page = 1;
            loadHomes(true);
        });

    });

});